/**
 * Talewave book page configs (minimal copy)
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'

// Provide a minimal theme so Book page components can safely access theme fields
// (templates expect config.theme.quoteColor and optionally tocLockColor)
export const theme = {
  // 使用 talewave.config.ts 中的主色作为基础进行派生
  primaryColor: '#6B92FD',
  quoteColor: 'rgba(107, 146, 253, 0.3)',
  tocLockColor: 'rgba(107, 146, 253, 0.6)',
  // 标签背景与文字颜色（Lanhu 设计）
  commonTagBg: '#EAFAFF',
  commonTagText: '#13C8FF',
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
